<template>
  <div>
    <GmapMarker
      v-if="place.location"
      :position="position" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      place: 'map/getGooglePlaceMarker'
    }),
    position: function () {
      return {
        lat: this.place.location.latitude,
        lng: this.place.location.longitude
      }
    }
  }
}
</script>
